import api from '../../../api.js';
import {loadUniverseById} from '../../components/UniverseLoader/actions.js';

export const types = {
  SET_SEARCH: 'Search/setSearch',
  SET_PAGINATION: 'Search/setPagination',
  SET_CHART: 'Search/setChart',
  START_LOADING: 'Search/startLoading',
  STOP_LOADING: 'Search/stopLoading',
  SET_ONE_RESULT: 'Search/setOneResult',
  SET_ALL_RESULTS: 'Search/setAllResults',
};

function startLoading() {
  return {
    type: types.START_LOADING
  };
}

function stopLoading() {
  return { 
    type: types.STOP_LOADING
  };
}

function setSearch(search) {
  return {
    type: types.SET_SEARCH,
    search
  };
}

function setAllResults(data) {
  return {
    type: types.SET_ALL_RESULTS,
    data,
  }
}

function setOneResult(index, value) {
  return {
    type: types.SET_ONE_RESULT,
    data: {index, value}
  }
}

export function updateResult(index, value) {
  return async (dispatch) => {
    dispatch(startLoading());
    dispatch(setOneResult(index, value));
    dispatch(stopLoading());
  }
}

export function searchFreelances(searchModel) {
  return search(api.freelances.search, searchModel);
}

export function searchOffers(searchModel) {
  return search(api.offers.search, searchModel);
}

export function searchPurchasers(searchModel) {
  return search(api.purchasers.search, searchModel);
}

function search(endpoint, {target, ...searchModel}) {
  return async (dispatch, getState) => {
    dispatch(startLoading());
    dispatch(setSearch({...searchModel, target: target}));

    if (parseInt(searchModel.universe, 10) !== getState().universe.currentUniverse.id) {
      dispatch(loadUniverseById(parseInt(searchModel.universe, 10)));
    }

    try {
      const data = (await endpoint(searchModel)).data;
      if (Array.isArray(data.scores) && data.scores.length === 0) {
        data.scores = {};
      }

      if (getState().search.search.target === target) {
        dispatch(setAllResults(data));
        dispatch(stopLoading());
      }
    } catch(e) {
      console.warn(e);
      dispatch(stopLoading());
    }
  };
}